import React from 'react';
import { TooltipProps } from 'recharts';

import styles from './widgets.module.css';
import Time from '../../../services/time.service';

export interface Coordinates { x: number; y: number; }

export const axisTickStyle = {
  fill: '#062960',
  fontFamily: 'Heebo',
  fontSize: 12
};

const ChartTooltip = (props: { perc?: boolean } & TooltipProps<number, string>) => {
  const { payload } = props;
  const date = new Date(props.label!);
  const perc = !!props.perc;
  let total = 0;
  if (!perc && payload) payload.forEach(pay => total += pay.value as number);
  const time = new Time(date);
  return (
    <div className={styles.customTooltip}>
      <div className={styles.customTooltipTitle}>
        {time.getLongDate()} {time.getShortTime()}
      </div>
      {payload && payload.map((elem) => {
        const value = perc ? Math.floor(elem.value as number * 1000) / 10 + '%' : elem.value!.toLocaleString();
        return (
        <React.Fragment key={elem.name}>
          <div className={styles.customTooltipText}>{elem.name}</div>
          <div className={styles.customTooltipColor} style={{backgroundColor: elem.color}}/>
          <div className={styles.customTooltipText}>{value}</div>
        </React.Fragment>);
      })}

      {!perc &&
        <div className={styles.customTooltipTotal}>
          Total: {total.toLocaleString()}
        </div>
      }
    </div>
  );
};

export default ChartTooltip;
